import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import classNames from 'classnames';
import { inject } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import CustomCol from '../../bootstrap/CustomCol';
import ConfigStore from '../../../store/ConfigStore';
import LeftSidebarLayout from "../LeftSidebarLayout";

const SidebarLayout = ({
  configStore,
  sidebar,
  content,
  className,
  sidebarPlaceHolder,
  contentPlaceHolder,
}) => {
  const fullWidthPage =
    configStore.navigation.sidebar.showFullWidthPageContent;

  return (
    <Row className={classNames('SidebarLayout', className)}>
      {fullWidthPage
        ? <CustomCol md={12}>{content || contentPlaceHolder}</CustomCol>
        : (
          <LeftSidebarLayout
            content={content}
            sidebar={sidebar}
            contentPlaceHolder={contentPlaceHolder}
            sidebarPlaceHolder={sidebarPlaceHolder}
          />
        )
      }
    </Row>
  );
};

SidebarLayout.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  sidebar: PropTypes.node,
  content: PropTypes.node,
  className: PropTypes.string,
  sidebarPlaceHolder: PropTypes.node,
  contentPlaceHolder: PropTypes.node,
};

export default inject('configStore')(SidebarLayout);
